
import Icon from '../../src/components/Icon.vue'

export default {
  install(Vue, options) {
    Vue.component('Icon', Icon)
  }
}
